import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect5OutV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33 35V65H63" stroke="#FFDD00" strokeWidth="2" />
      <path d="M1 1L31 1L31 31" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
